
import { AGENT_TYPE } from './../actions/agent'

export const PermissionValue = Object.freeze({
  ALLOW: 'allow',
  DENY: 'deny',
})

export const PERMISSIONS = {
  DEVICE: {
    VIEW: '2.1.1',
    KEYBOARD_MOUSE: '2.1.2',
    CLIPBOARD: '2.1.5',
    SELECT_MONITOR: '2.1.21',
  },
  ON_DEMAND: {
    VIEW: '5.1.1',
    KEYBOARD_MOUSE: '5.1.2',
  },
}


class PermissionsClass {
  constructor ({ agentType, permissions }) {
    this.agentType = agentType
    this.permissions = permissions
  }

  isMouseKbdAllowed = () => {
    if (this.agentType === AGENT_TYPE.ON_DEMAND) {
      return this.permissions[PERMISSIONS.ON_DEMAND.KEYBOARD_MOUSE]
    }
    if (this.agentType === AGENT_TYPE.INSTALLED_AGENT || this.agentType === AGENT_TYPE.CLASSROOM_AGENT) {
      return this.permissions[PERMISSIONS.DEVICE.KEYBOARD_MOUSE]
    }
    return false
  }
}

let permissionsInstance = null
export const createPermissionsInstance = ({ agentType, permissions }) => {
  if (!permissionsInstance) {
    const pObj = permissions
      .reduce((acc, { code, permission }) => {
        acc[code] = (permission === PermissionValue.ALLOW)
        return acc
      }, {})
    permissionsInstance = new PermissionsClass({ agentType, permissions: pObj })
  }
  return permissionsInstance
}
// for testing various cases
export const resetPermissionsInstance = () => { permissionsInstance = null }

export { permissionsInstance as Permissions }
